export default "__VITE_ASSET__Dx$uUe6$__"